import React from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { isEqual } from "lodash-es"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import {
  getDepartmentIdsToHide,
  hideDepartment,
  showDepartment,
  toggleFacilityVisibility,
} from "reduxSlices/formSubmissionTableSlice"
import { Checkbox } from "shared/checkboxes"
import ItemRow from "shared/ItemRow"

const FacilityFilter = ({
  facility,
  visibleDepartmentCount,
  totalDepartmentCount,
}) => {
  const dispatch = useDispatch()
  const departments = facility.departments || []

  const departmentIdsToHide = useSelector(getDepartmentIdsToHide, isEqual)

  const { pluralNameInSentence: departmentsName } = useCustomName(DEPARTMENT_KEY)

  const isDepartmentVisible = (id) => !departmentIdsToHide.includes(id)

  const facilityChecked = departments.some((d) => isDepartmentVisible(d.id))
  const facilityLabel = `facility-option-${facility.id}`

  const toggleDepartmentVisibility = (id) => () => {
    const updateFunction = isDepartmentVisible(id) ? hideDepartment : showDepartment

    dispatch(updateFunction(id))
  }

  return (
    <ItemRow
      key={facility.id}
      className="transparent border-lightgray-3"
      collapsable
      itemRowHeaderContentClassName="flex p-2 items-center"
      itemRowBodyClassName="p-2"
      itemRowHeaderContent={(
        <>
          <Checkbox
            uuid={facilityLabel}
            className="shrink-0 mr-2"
            value={facilityChecked}
            onChange={() => dispatch(toggleFacilityVisibility(facility))}
          />
          <div className="flex flex-col items-start grow">
            <label htmlFor={facilityLabel} className="text-sm font-medium grow">
              {facility.name}
            </label>
            <span className="text-xs font-normal text-dark"> ({visibleDepartmentCount} of {totalDepartmentCount} {departmentsName})</span>
          </div>
        </>
      )}
      itemRowBody={departments.map((dept) => (
        <div key={dept.id} className="py-1 flex items-center">
          <Checkbox
            uuid={`department-option-${dept.id}`}
            className="shrink-0 mr-2"
            value={isDepartmentVisible(dept.id)}
            onChange={toggleDepartmentVisibility(dept.id)}
          />
          <label htmlFor={`department-option-${dept.id}`} className="text-sm break-all min-w-0 mr-2">
            {dept.name}
          </label>
        </div>
      ))}
    />
  )
}

FacilityFilter.propTypes = {
  facility: types.object.isRequired,
  visibleDepartmentCount: types.number.isRequired,
  totalDepartmentCount: types.number.isRequired,
}

export default FacilityFilter
